import React, { useEffect } from 'react';
import * as THREE from 'three'; // Asegúrate de que esto esté en tu archivo
import { useThree } from '@react-three/fiber';
import Grid from '../elements/grid';  // Asegúrate de que Grid sea un componente que genera las líneas de la grilla
import Controls from '../controls/cameraControls'; // Importamos el componente de controles
import Columns from '../geometry/columns';
import Beams from '../geometry/beams';
import Slabs from '../geometry/slabs';

const Scene = ({ floors, selectedFloor, pivotPoint, gridPoints, nodes, columnsMatrix, heightMatrix, beamsMatrix, slabsMatrix, selectedSpacing, setSelectedSpacing, structuralCalculus, setSelectedAxesSpacing }) => 
{
  const { scene } = useThree(); // Obtenemos tanto la cámara como la escena
  
  // Añadir una luz básica a la escena
  useEffect(() => 
  {
    const light = new THREE.AmbientLight(0x404040, 1); // Luz ambiental suave
    scene.add(light);

    const directionalLight1 = new THREE.DirectionalLight(0xffffff, 0.8); // Luz direccional
    const directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.8); // Luz direccional

    directionalLight1.position.set(10, 10, 10);
    directionalLight2.position.set(-10, -10, -10);
    scene.add(directionalLight1, directionalLight2);
  }, [scene]);

  return (
    <group>
      <Controls
        pivot={pivotPoint}
      /> 

      <Grid
        floors={floors}
        heightMatrix = {heightMatrix}
        selectedFloor = {selectedFloor}
        gridPoints = {gridPoints}

        nodes={nodes}

        selectedSpacing = {selectedSpacing}
        setSelectedSpacing = {setSelectedSpacing}
        setSelectedAxesSpacing = {setSelectedAxesSpacing}
      /> 

      {columnsMatrix.length > 0 &&
        <Columns
          columns = {columnsMatrix}
          selectedFloor = {selectedFloor}

        /> 
      }
     
      {beamsMatrix.length > 0 &&
        <Beams
          beams = {beamsMatrix}
          selectedFloor = {selectedFloor}
          structuralCalculus = {structuralCalculus}
        /> 
      }

      {slabsMatrix.length > 0 &&
        <Slabs
          slabs = {slabsMatrix}
          selectedFloor = {selectedFloor}
          structuralCalculus = {structuralCalculus}
        /> 
      }      
     
    </group>
  );
};

export default Scene;
